import { GAMES_PREFIX } from "./DBPathConstants.js";
import { PrefixedFirebaseWrapper } from "./PrefixedFirebaseWrapper";
export class GameIdFirebaseWrapper extends PrefixedFirebaseWrapper {
    constructor(firebase, gameId) {
        super(firebase, `${GAMES_PREFIX}/${gameId}`);
    }
}
//# sourceMappingURL=GameIdFirebaseWrapper.js.map